export default "__VITE_ASSET__J55hV9cE__"